<template>
  <div class="login" v-if="isShow === false">
    <div v-if="id === 1">
      <el-row>
        <el-col :span="16">
          <div class="grid-content bg-purple">
            <img class="image" src="../account/images/logo2.png" alt="天耘科技" width="232" />
            <div class="content">
              <div class="ty">
                <div class="wenzi">会话管理系统</div>
                <div class="zi">ChatData Management System</div>
              </div>
              <div class="xian"></div>
              <div class="td">
                <div class="hui">会话数据存档</div>
                <div class="shu">数据应用场景建设</div>
              </div>
            </div>
            <div class="tw">
              <div class="hy">
                <img src="../account/images/Echart.png" width="434px" height="309px" />
              </div>
              <div>
                <div class="de">敏感事件预警及溯源</div>
                <div class="ki">客户联系数字化管理</div>
                <div class="ki">降低企业经营风险,提高营销转化能力</div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="right">
            <div class="er">
              <div class="wei" id="qrcode"></div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <div class="footer">
          <div>沪ICP备18027644号-1</div>
          <div>Copyright © 2022上海天耘信息科技有限公司 All Rights Reserved</div></div>
      </el-row>
    </div>
    <div v-else class="vfbd">
      <div class="buh">
        <div class="dfgu"><img class="image" src="../account/images/logo2.png" alt="天耘科技" width="232" /></div>
        <div class="dfhu">
          <img src="../../assets/images/lohs.png" width="145px" height="54px"/>
        </div>
      </div>
      <div class="sdfgs">
        <div class="content">
          <div class="ty">
            <div class="wenzi">会话管理系统</div>
            <div class="zi">ChatData Management System</div>
          </div>
          <div class="xian"></div>
          <div class="td">
            <div class="hui">会话数据存档</div>
            <div class="shu">数据应用场景建设</div>
          </div>
        </div>
        <div class="nkoyt">
          <div class="center">
            <div class="er">
              <div class="wei" id="qrcode"></div>
            </div>
          </div>
        </div>
        <div class="footer">
          <div>沪ICP备18027644号-1</div>
          <div>Copyright © 2022上海天耘信息科技有限公司 All Rights Reserved</div>
        </div>
      </div>
    </div>
  </div>
  <div class="no-found" v-else>
    <img class="img" src="../../assets/images/error.png" width="300" />
    <p class="ti">请在PC端打开此应用</p>
  </div>
</template>
<script>
import '../../utils/wwLogin'
// import md5 from 'js-md5'
// import { apiUrl } from '@/config/constant'
export default {
  data() {
    return {
      isShow: false,
      id: 1
    }
  },
  mounted() {
    const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    const a = localStorage.getItem('corpid')
    if (flag) {
      // 手机端
      // const b = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + a + '&redirect_uri=http%3A%2F%2Fweyun-test-web.tyunai.cn%2Fapi%2Fshow%2Fmobile%2Fuserinfo&response_type=code&scope=snsapi_base&state=' + '#wechat_redirect'
      // console.log('https://open.weixin.qq.com/connect/oauth2/authorize?appid=${a}&redirect_uri=https%3A%2F%2Fweyun-dev-web.tyunai.cn%2Fapi%2Fshow%2Fmobile%2Fuserinfo&response_type=code&scope=snsapi_base&state=a#wechat_redirect')
      // window.location.href = b
      this.isShow = true
      return true
    } else {
      // pc端
      this.isShow = false
      this.getWith()
      this.getLogin()
    }
    //  this.getLogin()
    //  const date = new Date().getTime()
    //  const state = md5(String(date)) + date
    // const apiUrl = 'http://chatdata.test.api.tyunai.cn'

    //   window.WwLogin({
    //     id: 'qrcode',
    //     // 天耘
    //     // appid: 'ww33c326dfaaa1b4e9',
    //     // agentid: '1000031',
    //     // 天耘2
    //     // appid: 'ww00ad695f1455682c',
    //     // agentid: '1000008',
    //     // 上海霖策商务
    //     // appid: 'ww1471fd993203943f',
    //     // agentid: '1000002',
    //     // 北京小悦科技
    //     // appid: 'wwd9e8ab4e790b6b51',
    //     // agentid: '1000010',
    //     // 帝亚实业
    //     // appid: 'ww71cb2f6f20705ab8',
    //     // agentid: '1000002',
    //    // 莱绅通灵珠宝
    //     appid: 'wx33aab90c288c4bab',
    //     agentid: '1000092',
    //     // redirect_uri: `${apiUrl}/dashboard`,
    //     redirect_uri: 'http://chatdata-api.leysen1855.com:8080/api/system/redirect'
    //   //  state: state
    //  })
  },
  methods: {
    getWith() {
      if (document.body.clientWidth <= 1400) {
        this.id = 2
      }
    },
    getLogin() {
      sessionStorage.removeItem('token')
      this.$api.get('/api/system/login', {
        corpid: localStorage.getItem('corpid')
      }).then((res) => {
        const corpid = res.corpid
        sessionStorage.setItem('corpid', corpid)
        window.WwLogin({
          id: 'qrcode',
          appid: res.corpid,
          agentid: res.agentId,
          redirect_uri: res.redirect_uri
        })
        // sessionStorage.removeItem('corpid')
        // sessionStorage.clear()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.grid-content{

  .image{
    width: 10.125rem;
    height: 2.838125rem;
    margin-top: 37px;
    margin-left: 38px;
  }
  .content{
    display: flex;
    margin-top:105px;
    margin-left:200px;
    .ty{
      width: 392px;
      padding: 8px;
      text-align:left;
      .wenzi{
        width: 390px;
        height: 60px;
        word-break: break-all;
        font-size: 60px;
        line-height: 32px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #204A9E;
        text-shadow: 1px 1px 1px rgba(0, 22, 67, 0.2);
        letter-spacing: 5px;
        opacity: 1;
      }
      .zi{
        width: 392px;
        height: 27px;
        font-size: 25.5px;
        margin-top: -10px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #204A9E;
        text-shadow: 1px 1px 1px rgba(0, 22, 67, 0.2);
        opacity: 1;
      }
    }
    .xian{
      width: 3px;
      height: 87px;
      margin-left: 16px;
      background: #204A9E;
      opacity: 1;
    }
    .td{
      margin-left: 26px;
      .hui{
        width: 256px;
        height: 40px;
        font-size: 32px;
        font-weight: 400;
        line-height: 40px;
        color: #204A9E;
        text-shadow: 1px 1px 1px rgba(0, 22, 67, 0.2);
        opacity: 1;
      }
      .shu{
        width: 256px;
        height: 40px;
        font-size: 32px;
        font-weight: 400;
        line-height: 40px;
        color: #204A9E;
        text-shadow: 1px 1px 1px rgba(0, 22, 67, 0.2);
        opacity: 1;
      }
    }
  }
  .tw{
    display: flex;
    margin-top: 107px;
    margin-left: 200px;
    .hy{
      padding: 0 -31px;
      //  border: 1px dashed black;
    }
    .de{
      width:180px;
      word-wrap:break-word;
      font-size: 20px;
      margin-top: 150px;
      margin-left: 31px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 14px;
      color: #8D99A3;
      text-shadow: 1px 1px 1px rgba(141, 153, 163, 0.12);
      opacity: 1;
    }
    .ki{
      width:325px;
      word-wrap:break-word;
      font-size: 20px;
      margin-top: 40px;
      margin-left: 31px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 14px;
      color: #8D99A3;
      text-shadow: 1px 1px 1px rgba(141, 153, 163, 0.12);
      opacity: 1;
    }
  }
}
.right {
  position: absolute;
  top: 220px;
  right: 7%;
  width: 350px;
  text-align: center;
  // background: #fff;
  // box-shadow: 0px 0px 40px 0px rgba(2, 47, 50, 0.1);
  border-radius: 10px;
  z-index: 999;
  // text-align: rigth;
  .er{
    width: 320px;
    //height: 18.75rem;
    // margin-top: 210px;
    padding: 24px;
    text-align: center;
    background: linear-gradient(210deg, #204A9E 0%, #1A3C81 100%);
    box-shadow: 0px 10px 30px rgba(0, 22, 67, 0.4);
    opacity: 1;
    border-radius: 20px;
    .wei{
      width: 320px;
      height: 385px;
      background: #FFFFFF;
      box-shadow: 0px 0px 30px rgba(0, 22, 67, 0.51);
      opacity: 1;
      border-radius: 12px;
      padding-top: 15px;
    }
  }
  h2 {
    font-size: 36px;
    font-weight: bold;
    color: #06c1db;
  }
}
.footer{
  width: 100%;
  text-align: center;
  font-size: 14px;
  margin-top: 7%;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 37px;
  color: #204A9E;
  opacity: 0.8;
  div{
    height: 15px;
  }
}
.no-found {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
  .img{
    width: 258.04px;
    height: 266.03px;
  }
  .ti{
    height: 33px;
    font-size: 24px;
    font-weight: 500;
    line-height: 20px;
    color: #27282D;
    opacity: 1;
  }
}
::v-deep .impowerBox .qrcode {
  width: 230px;
  vertical-align: top;
}
.vfbd{
  width: 100%;
  margin: 37px 38px;
  .buh{
    width: 100%;
    display: flex;
    align-items: center;
    .dfgu{
      width: 50%;
      // padding-left: 38px;
      .image{
        width: 162px;
        height: 45.41px;
      }
    }
    .dfhu{
      width: 50%;
      text-align: right;
      padding-right: 38px;
    }
  }
  .sdfgs{
    width: 100%;
    .content{
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 79px;
      .ty{
        text-align:left;
        .wenzi{
          height: 50px;
          word-break: break-all;
          font-size: 41px;
          line-height: 32px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #204A9E;
          text-shadow: 1px 1px 1px rgba(0, 22, 67, 0.2);
          letter-spacing: 5px;
          opacity: 1;
        }
        .zi{
          font-size: 16px;
          margin-top: -10px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #204A9E;
          letter-spacing: 1.2px;
          text-shadow: 1px 1px 1px rgba(0, 22, 67, 0.2);
          opacity: 1;
        }
      }
      .xian{
        width: 2px;
        height: 60px;
        margin-left: 11px;
        background: #204A9E;
        opacity: 1;
      }
      .td{
        margin-left: 11px;
        .hui{
          font-size: 22px;
          font-weight: 400;
          color: #204A9E;
          text-shadow: 1px 1px 1px rgba(0, 22, 67, 0.2);
          opacity: 1;
        }
        .shu{
          font-size: 22px;
          font-weight: 400;
          line-height: 35px;
          color: #204A9E;
          text-shadow: 1px 1px 1px rgba(0, 22, 67, 0.2);
          opacity: 1;
        }
      }
    }
    .nkoyt{
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 24px;
      .center {
        text-align: center;
        border-radius: 10px;
        .er{
          width: 320px;
          padding: 24px;
          text-align: center;
          background: linear-gradient(210deg, #204A9E 0%, #1A3C81 100%);
          box-shadow: 0px 10px 30px rgba(0, 22, 67, 0.4);
          opacity: 1;
          border-radius: 20px;
          .wei{
            width: 320px;
            height: 385px;
            background: #FFFFFF;
            box-shadow: 0px 0px 30px rgba(0, 22, 67, 0.51);
            opacity: 1;
            border-radius: 12px;
            padding-top: 15px;
          }
        }
        h2 {
          font-size: 36px;
          font-weight: bold;
          color: #06c1db;
        }
      }
    }
  }
}

</style>
